<template>
  <Modal v-model="isShow" width="65%" :closable="false" :mask-closable="false">
    <div slot="header" class="info-header">
      <div class="ivu-modal-header-inner">账户充值</div>
      <a class="ivu-modal-close" @click="closeModel"><i class="ivu-icon ivu-icon-ios-close"></i></a>
    </div>
    <div>
      <Form ref="accountinfoForm" :model="form" :label-width="80" :rules="ruleValidate">
        <Row>
          <Col span="8">
            <FormItem label="账户" prop="accountNo">
              <Input v-model="form.accountNo" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="账户名称" prop="name">
              <Input v-model="form.name" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="应用" prop="appid">
              <Input v-model="form.appid" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="类型" prop="type">
              <Input v-model="form.type" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="用户名称" prop="userName">
              <Input v-model="form.userName" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="用户手机" prop="userPhone">
              <Input v-model="form.userPhone" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="充值金额（单位分）" prop="money">
              <Input v-model="form.money"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
    <div slot="footer">
      <Button @click="closeModel">取消</Button>
      <Button type="primary" @click="submit">充值</Button>
    </div>
  </Modal>
</template>

<script>

export default {
  name: 'accountinfo-info',
  data () {
    return {
      form: {},
      isShow: false,
      type: 'add',
      disable: false,
      ruleValidate: {
        name: [
          { required: true, message: '账户名称不允许为空', trigger: 'blur' }
        ],
        appid: [
          { required: true, message: '应用不允许为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '类型不允许为空', trigger: 'blur', type: 'number' }
        ],
        isRecharge: [
          { required: true, message: '是否允许充值不允许为空', trigger: 'blur', type: 'number' }
        ],
        isCash: [
          { required: true, message: '是否允许提现不允许为空', trigger: 'blur', type: 'number' }
        ],
        isBalanceNegative: [
          { required: true, message: '是否允许余额为负不允许为空', trigger: 'blur', type: 'number' }
        ]
      }
    }
  },
  methods: {
    openModel (type, data) {
      this.isShow = true
      this.type = type
      if (data) {
        this.form = data
      } else {
        this.form = {}
      }
      this.disable = type === 'detail'
    },
    closeModel () {
      this.isShow = false
    },
    submit () {
      this.$refs.accountinfoForm.validate((valid) => {
        if (valid) {
          this.P('trade/account/appRecharge?tenantIdData=' + this.form.tenantId + '&money=' + this.form.money +
            '&tradeNo=' + this.getUuid()).then(data => {
            this.isShow = false
            this.$emit('handle-search')
          })
        } else {
          this.$Message.error('请检查填写的数据')
        }
      })
    },
    getUuid () {
      let s = []
      let hexDigits = '0123456789abcdef'
      for (let i = 0; i < 32; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
      }
      s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23]
      let uuid = s.join('')
      return uuid
    }
  },
  mounted: function () {
  }
}
</script>
